module.exports = __webpack_public_path__ + "media/images/icon__whatsapp@2x-f08721ec0c14abf5bf8230b6197b7b7b.png";